import { Address } from "../types/address";

export const parseAddress = (address: any): string => {
    if (!address) {
        return "";
    }
    const { city, state } = address;
    if (city && state) {
        return `${city}, ${state}`;
    } else if (city) {
        return city;
    } else if (state) {
        return state;
    }
    return "";
};

export interface LocationType {
    name: string;
    latitude: number;
    longitude: number;
    picture?: string;
    id?: number;
}
// return list of locations
export const parseAddressesForMap = (cigars: any[], filter_type?: string): LocationType[] => {
    if (filter_type && filter_type === 'retailer' || !(cigars.length > 0 && cigars[0].location)) {
        return cigars.map((retailer, index) => ({
            name: parseAddress(retailer.address),
            latitude: retailer.latitude,
            longitude: retailer.longitude,
            picture: retailer.picture,
            id: retailer.id || index
        }));
    }
    console.log("CIGGG ", cigars);
    return cigars.map((cigar, index) => {
        // Handle both formats: lightweight map data (latitude/longitude at top level)
        // and full cigar data (latitude/longitude nested in location object)
        const lat = cigar.latitude || cigar.location?.latitude;
        const lng = cigar.longitude || cigar.location?.longitude;
        const name = cigar.product_name || parseAddress(cigar.location);
        const picture = cigar.user_profile_picture || cigar.product_picture;

        return {
            name: name,
            latitude: lat,
            longitude: lng,
            picture: picture,
            id: cigar.id || index
        };
    });
};